import { parseUserAgent } from "@/lib/ua";

/**
 * Table cell for a user-agent string: parsed form (browser · OS · device)
 * inline, the full string on hover. Used by the click timeline and every
 * miss-log view.
 */
export function UaCell({ ua }: { ua: string | null }) {
	const parsed = parseUserAgent(ua);
	return (
		<td
			className="max-w-[16rem] truncate px-3 py-2 text-xs"
			title={ua ?? undefined}
		>
			{ua ? `${parsed.browser} · ${parsed.os} · ${parsed.device}` : "—"}
		</td>
	);
}
